var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-expiration-select p-expiration-select--year"},[_c('dropdown-select',{attrs:{"name":_vm.name,"list":_vm.yearList,"value":("" + _vm.value),"wrapperClass":"u-full"},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }